import AttendedIcon from "icons/AttendedIcon";
import CheckIcon from "icons/CheckIcon";
import UniversitySpaceScheduleActivityCard from "../../UniversitySpaceScheduleActivityCard";

const SpaceScheduleActivityCard = ({
	header, classList, $activity,
	quantityCells, 
	updateActivityPopup, reservation
}) => {
	const hasReservationState = typeof reservation.finalized === "boolean";
	const getNewClassList = () => {
        const newClassList = [];
        hasReservationState && classList.push(reservation.finalized ? "finalized" : "on-use");
        return [...classList, ...newClassList];
    }
	return (
		<UniversitySpaceScheduleActivityCard
			classList={getNewClassList()} 
			header={header}
			activity={$activity}
			dialogUpdate={updateActivityPopup.popup}
			quantityCells={quantityCells}
			icon={hasReservationState ? (
				reservation.finalized
				? <CheckIcon className="icon" />
				: <AttendedIcon className="icon" />
			) : null}/>
	);
}	
	
export default SpaceScheduleActivityCard;